import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
	header: {
		display: "flex",
		flexShrink: 0,
		flexDirection: "column",
		padding: "2.4rem 1.6rem",
		alignItems: "center",
		justifyContent: "center",
	},
	headerMd: {
		display: "flex",
		flexShrink: 0,
		flexDirection: "column",
		padding: "0 1.6rem",
		alignItems: "start",
		justifyContent: "start",
		height: "156px",
	},
	logo: {
		height: "56px",
	},
	logoMd: {
		height: "88px",
	},
}));
